/* global BigInt */

import React, { useState, useEffect, useRef } from 'react';

function App() {
  const [latestRandomness, setLatestRandomness] = useState(null);
  const [eta, setETA] = useState(0);
  const [round, setRound] = useState(null);
  const [network, setNetwork] = useState('default');
  const intervalRef = useRef(null);
  const countdownRef = useRef(null);

  const fetchLatestRandomness = async (updateInterval) => {
    try {
      let chainHash;
      if (network === 'default') {
        chainHash = '8990e7a9aaed2ffed73dbd7092123d6f289930540d7651336225dc172e51b2ce';
      } else if (network === 'quicknet') {
        chainHash = '52db9ba70e0cc0f6eaf7803dd07447a1f5477735fd3f661792ba94600c84e971';
        updateInterval = 3000; // quicknet update interval in milliseconds
      }

      let urls = [
        'https://api.drand.sh',
        'https://api2.drand.sh',
        'https://api3.drand.sh',
        'https://drand.cloudflare.com'
      ];

      if (network === 'quicknet') {
        urls = urls.map(url => `${url}/${chainHash}/public/latest`);
      } else {
        urls = urls.map(url => `${url}/public/latest`);
      }

      const fetchFromFastestUrl = async () => {
        const fetchPromises = urls.map(url =>
          fetch(url).then(response => response.json())
        );

        const results = await Promise.race(fetchPromises);
        return results;
      };

      const data = await fetchFromFastestUrl();
      const currentTime = new Date().getTime();
      const nextETA = currentTime + updateInterval;

      setRound(data.round);
      setLatestRandomness(`${data.randomness}`);

      // Clear the previous countdown interval
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }

      countdownRef.current = setInterval(() => {
        const now = new Date().getTime();
        const remainingTime = nextETA - now;

        if (remainingTime <= 1000) {
          clearInterval(countdownRef.current);
          setETA(0); // Reset ETA when time reaches 1 second
          fetchLatestRandomness(updateInterval); // Immediately fetch new randomness
        } else {
          const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
          const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
          setETA(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
        }
      }, 1000);
    } catch (error) {
      console.error('Error fetching randomness:', error);
    }
  };

  useEffect(() => {
    const updateInterval = network === 'default' ? 30000 : 3000;
    fetchLatestRandomness(updateInterval);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => fetchLatestRandomness(updateInterval), updateInterval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, [network]);

  const handleNetworkChange = (event) => {
    setNetwork(event.target.value);
  };

  // Styles to ensure the widget remains bright
  const widgetStyles = {
    color: '#000', // Text color
    backgroundColor: '#fff', // Background color
    padding: '20px', // Padding for spacing
    borderRadius: '8px', // Rounded corners
    boxShadow: '0 0 10px rgba(0,0,0,0.1)' // Subtle shadow
  };

  return (
    <div className="App" style={widgetStyles}>
      <header className="App-header">
        <h1>Latest Randomness from drand Beacon</h1>

        <div>
          Select Beacon Network:
          <select value={network} onChange={handleNetworkChange} style={{ marginLeft: '10px' }}>
            <option value="default">Default</option>
            <option value="quicknet">Quicknet</option>
          </select>
        </div>

        <br />

        Next Randomness ETA: {eta}

        <br />

        Latest Round: {round}

        <br />

        Latest Randomness: {latestRandomness}
      </header>
    </div>
  );
}

export default App;
